import { render, staticRenderFns } from "@/template/Soal.html?vue&type=template&id=6df1da70&scoped=true&"
import script from "./Soal.vue?vue&type=script&lang=ts&"
export * from "./Soal.vue?vue&type=script&lang=ts&"
import style0 from "./Soal.vue?vue&type=style&index=0&id=6df1da70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df1da70",
  null
  
)

export default component.exports